import { render, staticRenderFns } from "./Appreciate.vue?vue&type=template&id=424e0c4c"
import script from "./Appreciate.vue?vue&type=script&lang=js"
export * from "./Appreciate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports